import { Box, CardMedia, Typography } from '@mui/material';
import React from 'react';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

const TimelineTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.common.white,
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.white,
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.white,
        color: '#1B1B1B',
        boxShadow: '-2px 2px 8px rgba(229, 228, 255, 0.83)',
        fontFamily: 'poppins',
        fontSize: '14px',
        padding: '12px',
    },
}));

const SmallDeviceTimeLine = () => {
    return (
        <div>
            <Box sx={{ display: 'flex', alignItems: 'center', py: '20px' }}>
                <Box className="first-box" sx={{ height: { xs: '30px', sm: '40px', md: '50px', lg: '61px' }, width: { xs: '9px', sm: '12px', md: '15px', lg: '21px' }, background: '#4741E4' }}></Box>
                <Box className="second-box" sx={{ height: { xs: '30px', sm: '40px', md: '50px', lg: '61px' }, width: { xs: '9px', sm: '12px', md: '15px', lg: '21px' }, background: '#7E89FF' }}></Box>
                <Typography sx={{ fontFamily: 'poppins', fontWeight: 500, fontSize: { xs: '20px', sm: '22px', md: '25px', lg: '30px' }, lineHeight: { xs: '30px', lg: '45px' }, color: '#383838', textAlign: 'left', pl: { xs: '18px', sm: '22px', md: '28px', lg: '36px' } }}>
                    What’s Our <span style={{ fontWeight: 700, color: '#433ED1' }}>Timeline</span>
                </Typography>
            </Box>

            <Box sx={{ px: '20px', pt: '70px', pb: '24px' }}>
                {/* first timeline box */}
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <TimelineTooltip title="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Dignissim viverra cras porta erat." placement="top-end">
                        <CardMedia
                            component="img"
                            sx={{ width: '36px', mr: '10px', p: '10px', borderRadius: '50%', background: '#EEEFFF' }}
                            image="https://i.ibb.co/8dBKgsn/timeline.png"
                            alt="logo"
                        />
                    </TimelineTooltip>
                    <Box sx={{ pl: '10px' }}>
                        <Typography sx={{ fontFamily: 'poppins', fontWeight: 500, fontSize: '14px', lineHeight: '21px', textAlign: 'left', color: '#433ED1' }}>Milestone Title</Typography>

                        <Typography sx={{ fontFamily: 'poppins', fontWeight: 300, fontSize: '11px', lineHeight: '16px', textAlign: 'left', color: '#383838', pt: '3px' }}>5th December 2020</Typography>
                    </Box>
                </Box>
                <Box sx={{ mx: '27px', borderLeft: '0.5px solid #5561F7', borderBottom: '0.5px solid #5561F7', height: '30px' }}></Box>
                <Box sx={{ mx: '27px', borderRight: '0.5px solid #5561F7', height: '30px' }}></Box>

                {/* second timeline box */}
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
                    <Box sx={{ pr: '10px' }}>
                        <Typography sx={{ fontFamily: 'poppins', fontWeight: 500, fontSize: '14px', lineHeight: '21px', textAlign: 'left', color: '#433ED1' }}>Milestone Title</Typography>

                        <Typography sx={{ fontFamily: 'poppins', fontWeight: 300, fontSize: '11px', lineHeight: '16px', textAlign: 'left', color: '#383838', pt: '3px' }}>10th March 2020</Typography>
                    </Box>
                    <TimelineTooltip title="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Dignissim viverra cras porta erat." placement="top-end">
                        <CardMedia
                            component="img"
                            sx={{ width: '36px', ml: '10px', p: '10px', borderRadius: '50%', background: '#EEEFFF' }}
                            image="https://i.ibb.co/8dBKgsn/timeline.png"
                            alt="logo"
                        />
                    </TimelineTooltip>
                </Box>
                <Box sx={{ mx: '27px', borderRight: '0.5px solid #5561F7', borderBottom: '0.5px solid #5561F7', height: '30px' }}></Box>
                <Box sx={{ mx: '27px', borderLeft: '0.5px solid #5561F7', height: '30px' }}></Box>

                {/* third timeline box */}
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <TimelineTooltip title="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Dignissim viverra cras porta erat." placement="top-end">
                        <CardMedia
                            component="img"
                            sx={{ width: '36px', mr: '10px', p: '10px', borderRadius: '50%', background: '#EEEFFF' }}
                            image="https://i.ibb.co/8dBKgsn/timeline.png"
                            alt="logo"
                        />
                    </TimelineTooltip>
                    <Box sx={{ pl: '10px' }}>
                        <Typography sx={{ fontFamily: 'poppins', fontWeight: 500, fontSize: '14px', lineHeight: '21px', textAlign: 'left', color: '#433ED1' }}>Milestone Title</Typography>

                        <Typography sx={{ fontFamily: 'poppins', fontWeight: 300, fontSize: '11px', lineHeight: '16px', textAlign: 'left', color: '#383838', pt: '3px' }}>20th Sept 2020</Typography>
                    </Box>
                </Box>
                <Box sx={{ mx: '27px', borderLeft: '0.5px solid #5561F7', borderBottom: '0.5px solid #5561F7', height: '30px' }}></Box>
                <Box sx={{ mx: '27px', borderRight: '0.5px solid #5561F7', height: '30px' }}></Box>

                {/* fourth timeline box */}
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
                    <Box sx={{ pr: '10px' }}>
                        <Typography sx={{ fontFamily: 'poppins', fontWeight: 500, fontSize: '14px', lineHeight: '21px', textAlign: 'left', color: '#433ED1' }}>Milestone Title</Typography>

                        <Typography sx={{ fontFamily: 'poppins', fontWeight: 300, fontSize: '11px', lineHeight: '16px', textAlign: 'left', color: '#383838', pt: '3px' }}>22nd December 2019</Typography>
                    </Box>
                    <TimelineTooltip title="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Dignissim viverra cras porta erat." placement="top-end">
                        <CardMedia
                            component="img"
                            sx={{ width: '36px', ml: '10px', p: '10px', borderRadius: '50%', background: '#EEEFFF' }}
                            image="https://i.ibb.co/8dBKgsn/timeline.png"
                            alt="logo"
                        />
                    </TimelineTooltip>
                </Box>
            </Box>
        </div>
    );
};

export default SmallDeviceTimeLine;